import React from 'react';
import { Button } from 'antd';
import CustomModal from './CustomModal';

/**
 * CustomFormModal - Modal optimizado para formularios con botones estándar
 *
 * Props adicionales a CustomModal:
 * - onOk: function - Función que se ejecuta al hacer click en "Guardar"
 * - okText: string - Texto del botón principal (default: "Guardar")
 * - cancelText: string - Texto del botón cancelar (default: "Cancelar")
 * - loading: boolean - Si el modal está en estado de carga
 * - disabled: boolean - Si el botón principal está deshabilitado
 * - showFooter: boolean - Si mostrar los botones del footer (default: true)
 */

const CustomFormModal = ({
    onOk,
    onCancel,
    okText = "Guardar",
    cancelText = "Cancelar",
    loading = false,
    disabled = false,
    showFooter = true,
    headerColor = '#253289',
    children,
    ...modalProps
}) => {
    const footer = showFooter ? (
        <div style={{
            textAlign: 'center',
            padding: '16px 24px',
            borderTop: '1px solid #f0f0f0',
            marginTop: '24px'
        }}>
            <Button
                key="cancel"
                onClick={onCancel}
                style={{
                    marginRight: 12,
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: '500'
                }}
            >
                {cancelText}
            </Button>
            <Button
                key="submit"
                type="primary"
                onClick={onOk}
                loading={loading}
                disabled={disabled}
                style={{
                    background: disabled
                        ? '#d9d9d9'
                        : (headerColor.includes('linear-gradient')
                            ? headerColor
                            : `linear-gradient(135deg, ${headerColor} 0%, ${headerColor}dd 100%)`),
                    borderColor: disabled ? '#d9d9d9' : headerColor,
                    color: disabled ? '#000000' : 'white',
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: '500',
                    boxShadow: disabled ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}
            >
                {okText}
            </Button>
        </div>
    ) : null;

    return (
        <CustomModal
            onCancel={onCancel}
            footer={footer}
            headerColor={headerColor}
            {...modalProps}
        >
            {children}
        </CustomModal>
    );
};

export default CustomFormModal;